import React from "react";
import { useTranslation } from "react-i18next";
import { SelectInput } from "../../common/SelectInput";

export function CategorySection({ categories, categoryId, setField }) {
  const { t } = useTranslation();

  return (
    <SelectInput
      label={t("categories")}
      name="categoryId"
      value={categoryId}
      onChange={e => setField("categoryId", e.target.value)}
      options={categories.map(cat => ({ label: cat.name, value: cat.id }))}
      required
    />
  );
}